import { createAction } from '@reduxjs/toolkit';

const setRegistration = createAction('vehicle/setRegistration');
const clearRegistration = createAction('vehicle/clearRegistration');

export { setRegistration, clearRegistration };
